<!--
 * @Description: 
 * @Date: 2020-11-14 17:08:35
-->
<template>
  <div class="living">
    <div v-if="!isDesktop">
      <template v-if="show">
        <template v-if="showLive">
          <!-- 问卷限制 -->
          <living-survey v-if="showSurvey"></living-survey>
          <template v-else>
            <living-video class="video-dom"></living-video>
            <living-title></living-title>
            <living-rela
              style="border-top: 0.09rem solid #ededed"
            ></living-rela>
            <living-tabs></living-tabs>
            <living-content></living-content>
            <living-cover></living-cover>
            <living-gift :currentUserGift="gift"></living-gift>
            <ToYsh class="toYsh" />
          </template>
        </template>
        <div v-else class="tips">
          <img src="@/assets/icon.png" alt class="icon" />
          <div>
            <p>很抱歉，您没有权限观看本次直播，</p>
            <p>请联系相关人员开通权限。</p>
          </div>
        </div>
      </template>
    </div>
    <div v-if="isDesktop">
      <template v-if="showLive">
        <living-survey v-if="showSurvey"></living-survey>
        <PcLiving v-else>
          <template slot="video">
            <living-video></living-video>
          </template>
          <template slot="title">
            <living-title></living-title>
            <living-rela
              style="border-top: 0.09rem solid #ededed"
            ></living-rela>
          </template>
          <template slot="tabs">
            <living-tabs :activeindex.sync="index"></living-tabs>
            <div>
              <survey
                v-if="(PcLivingData[index] || {}).type === 2"
                :questionnaireId="PcLivingData[index].questionnaireId"
                :key="PcLivingData[index].questionnaireId"
              ></survey>
              <div
                class="pre"
                v-if="(PcLivingData[index] || {}).type === 1"
                v-html="(PcLivingData[index] || {}).content || '无'"
              ></div>
            </div>
            <living-cover></living-cover>
            <living-gift :currentUserGift="gift"></living-gift>
          </template>
        </PcLiving>
      </template>
      <div v-else class="tips">
        <img src="@/assets/icon.png" alt class="icon" />
        <div>
          <p>很抱歉，您没有权限观看本次直播，</p>
          <p>请联系相关人员开通权限。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PcLiving from '@/components/pcliving/pclliving';
import LivingGift from './components/livingGift';
import LivingRela from './components/livingRela';
import LivingTabs from './components/livingTabs';
import LivingContent from './components/livingContent';
import dateFormat from '@/utils/dateFormat';
import LivingSurvey from './components/livingSurvey';
import LivingCover from './components/livingCover';
import LivingVideo from './components/livingVideo';
import LivingTitle from './components/livingTitle';
import ToYsh from '@/components/toYsh';
import survey from '@/views/survey';
import { mapState } from 'vuex';
import {
  storageUserInfo,
  getStorage,
  setBeforeRegisterUrl
} from '@/utils/storage';
import { queryliveZdyMenuList } from '@/api/course';
export default {
  name: 'Living',
  provide() {
    return {
      livingStore: this.livingStore,
      isDesktop: this.isDesktop
    };
  },
  data() {
    return {
      dateFormat,
      bgUrl: '',
      index: 0,
      PcLivingData: [],
      show: false,
      saTimer: null, // 神策定时上报
      gift: {} // 礼物
    };
  },
  components: {
    PcLiving,
    LivingGift,
    LivingTabs,
    LivingContent,
    LivingSurvey,
    LivingRela,
    LivingCover,
    LivingVideo,
    LivingTitle,
    ToYsh,
    survey
  },
  computed: {
    ...mapState({
      isDesktop: state => state.living.isDesktop,
      livingStore: state => state.living,
      detail: state => state.living.detail,
      livingConf: state => state.living.livingConf,
      livingStatus: state => state.living.livingStatus,
      whiteStatus: state => state.living.whiteStatus
    }),
    isAdmin() {
      return this.$route.query.flag === 'admin';
    },
    showSurvey() {
      if (this.isAdmin) {
        // 预览模式
        return false;
      }
      const { checkInfo, isSubmitCheck } = this.$store.state.living;
      const { id: userId } = storageUserInfo();
      if (userId) {
        // 有用户
        return Object.keys(checkInfo).length > 0 && !isSubmitCheck;
      } else {
        return (
          Object.keys(checkInfo).length > 0 &&
          getStorage('hideLiveSurvey') != this.livingConf.courseId
        );
      }
    },
    showLive() {
      if (this.isAdmin) {
        // 预览模式
        return true;
      }
      if (!this.show) {
        return true;
      }
      if (this.whiteStatus == 1) {
        return false;
      } else if (this.whiteStatus == 2) {
        return false;
      }
      return true;
    }
  },
  watch: {
    livingStatus: {
      immediate: true,
      handler(v) {
        // 跳转到录播
        if (v === 6) {
          this.$router.replace({
            name: 'courseDetail',
            params: { id: this.$route.params.id }
          });
        }
      }
    },
    $route: {
      handler() {
        this.init();
      }
    }
  },
  methods: {
    async checkWhiteStatus() {
      if (this.whiteStatus == 1) {
        // 需要登录
        setBeforeRegisterUrl();
        const channelNo = this.$router.currentRoute.params.channelNo;
        const storageName = 'channel' + channelNo;
        localStorage.removeItem(storageName);
        this.$store.commit('user/SET_INFO', {});
        //去注册
        this.$router.replace({
          name: 'register'
        });
      }
    },
    // 创建socket链接与消息接收处理
    registerSocket() {
      window.dmsocket = new WebSocket(
        `${this.$config.webSocketPath}/ws?channel=jhss_${this.$route.params.channelNo}_${this.detail.id}`
      );
      window.dmsocket.onopen = () => {
        // 解析socket返回数据
        const getMessageValue = data => {
          let index = data.indexOf(':');
          let prefix = data.substr(0, index);
          let value = null;
          try {
            value = JSON.parse(data.substr(index + 1));
          } catch (e) {}
          return {
            prefix,
            value
          };
        };
        window.dmsocket.onmessage = event => {
          let data = event.data;
          let { prefix, value } = getMessageValue(data);
          // 初始化并上报当前链接
          if (prefix == 'INFO') {
            window.dmsocket.send(JSON.stringify({ type: 3 }));
          }
          // 接收礼物
          if (prefix == 'PRIZE') {
            this.gift = value;
          }
          // 实时人数
          if (prefix == 'REAL_PEOPLE') {
            let realUsers = value;
            this.$store.commit('living/SET_COMMON', {
              field: 'realUsers',
              value: realUsers.users
            });
          }
          // 总次数
          if (prefix == 'TOTAL_PEOPLE') {
            let totalUsers = value;
            this.$store.commit('living/SET_COMMON', {
              field: 'totalUsers',
              value: totalUsers.total
            });
          }
        };
      };
    },
    async setZdyMenuList() {
      const id = this.$route.params.id;
      let { pdata } = await queryliveZdyMenuList({ courseId: id });
      pdata = pdata.sort((a, b) => {
        return a.sort - b.sort;
      });
      this.PcLivingData = pdata;
    },
    async init() {
      try {
        window.dmsocket.close();
      } catch (e) {}
      await this.$store.dispatch('living/init');
      await this.checkWhiteStatus();
      let { courseName, videoPicUrl, courseContent, id } = this.detail;
      if (!this.show) {
        setTimeout(() => {
          this.show = true;
        }, 100);
      }
      if (!this.isAdmin && id) {
        if (
          this.livingConf.isOtherReplay == 1 &&
          this.livingConf.otherReplayId
        ) {
          // 如果关联录播，则跳转到指定录播界面
          this.$router.replace({
            name: 'courseDetail',
            params: { id: this.livingConf.otherReplayId }
          });
        }
        this.registerSocket();
        document.title = courseName;
        // 事件上报
        this.$sa.re_contentview({
          type: '直播', // 直播，录播，资讯，病例
          name: courseName, // 内容名字
          contentid: id // 内容id
        });

        // 注册分享
        this.$wxShare({
          title: courseName,
          imgUrl:
            videoPicUrl +
            '?x-oss-process=image/resize,w_200,h_200/auto-orient,1',
          desc: courseName,
          callback: () => {
            this.$sa.re_interaction({
              type: '分享', // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
              contentype: '直播', // 互动主体 直播，录播，资讯，病例，站内信，论坛, 调研
              contentid: id, // 内容id
              contentname: courseName
              //  source_user_id: this.$route.query.source_user_id || "", // 邀请人ID 全局使用
              //  projectId: this.$route.query.projectId || ""
            });
          }
        });
      }
      this.bgUrl = JSON.parse(
        sessionStorage.getItem('vuex')
      ).channel.info.bgUrl.replace(/http:|https:/, '');
    }
  },
  mounted() {
    //
  },
  async created() {
    this.init();
    this.setZdyMenuList();
    // 设置关联直播
    window.setCourseRela = relas => {
      this.$store.commit('living/SET_COMMON', {
        field: 'rela',
        value: relas
      });
    };

    // 设置直播详情
    window.setLivingDetail = detail => {
      this.$store.commit('living/SET_COMMON', {
        field: 'detail',
        value: { ...this.detail, ...detail }
      });
    };

    // 设置直播配置
    window.setLivingConfig = config => {
      this.$store.commit('living/SET_COMMON', {
        field: 'livingConf',
        value: { ...this.livingConf, ...config }
      });
    };
  },
  beforeDestroy() {
    this.saTimer && clearInterval(this.saTimer);
    try {
      window.dmsocket.close();
    } catch (e) {}
  }
};
</script>
<style lang="less" scoped>
.video-dom {
  position: sticky;
  top: 0;
  z-index: 1;
  // background: #000; 移动端会出现黑边
}
.livingtime {
  margin-top: 8px;
  display: flex;
  margin-bottom: 21px;
  & > p {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9394a0;
    line-height: 16px;
  }
  & > span {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #323235;
    line-height: 16px;
  }
}
.pre {
  & > p {
    max-width: 100%;
    word-break: break-all;
  }
}
.tips {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 14rem;
  font-size: 0.36rem;
  color: #9394a0;
  line-height: 2;
  text-align: center;
  .icon {
    width: 2.5rem;
  }
}
.toYsh {
  position: fixed;
  right: 0.23rem;
  bottom: 6.2rem;
}
</style>
